export const getAll = (retailerId: string) => ({
  className: 'Team',
  where: {
    retailer: {
      __type: 'Pointer',
      className: 'Retailer',
      objectId: retailerId,
    },
  },
  order: 'name',
  limit: 1000,
});

const TeamQueries = {
  getAll,
};

export default TeamQueries;
